module.exports = __webpack_public_path__ + "static/media/icon_wallet.3da5f49f.svg";